import { Protected } from "@stardeck/client-auth";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import AdminDashboard from "@/pages/admin/dashboard";
import CatsPage from "@/pages/cats";
import { Home } from "@/pages/home";
import Login from "@/pages/login";
import { NotFound } from "@/pages/not-found";

import { Providers } from "./providers";

function AppRoutes() {
  return (
    <Router>
      <Providers>
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/cats" element={<CatsPage />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <Protected redirectTo="/login">
                  <AdminDashboard />
                </Protected>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </Providers>
    </Router>
  );
}

export default AppRoutes;
